import type { FC } from 'react';
import { useDesktop } from '@utils/hooks/useDesktop';
import NavBarMobile from './NavBarMobile';
import NavBarDesktopV2 from './NavBarDesktopV2';
import NavBarDesktopV3 from './NavBarDesktopV3';
import { ENABLE_ORDERS_V2 } from '@utils/featureFlags';

const NavBar: FC = () => {
  const isDesktop = useDesktop();

  return isDesktop ? ENABLE_ORDERS_V2 ? <NavBarDesktopV3 /> : <NavBarDesktopV2 /> : <NavBarMobile />;
};

export default NavBar;
